import { lazy, Suspense } from 'react';
import { BottomSheet } from '../../ui/BottomSheet';
import styles from './Beat.module.css';

// The picker carries the key-by-ear drone and its audio, so it loads when a sheet opens (CLAUDE.md performance)
const KeyPicker = lazy(() => import('../harmony/KeyPicker'));

/** Project home's key sheet (SPEC F7): the shared key picker with the drone (SPEC F14). A key saves as soon as there is a root. */
export function KeySheet({ open, root, minor, onChange, onClose }: {
  open: boolean;
  root?: number;
  minor?: boolean;
  onChange: (key: { keyRoot: number; minor: boolean } | undefined) => void;
  onClose: () => void;
}) {
  return (
    <BottomSheet open={open} title="Key" onClose={onClose}>
      <div className={styles.sheetBody}>
        <Suspense fallback={null}>
          <KeyPicker root={root} minor={minor} onChange={onChange} />
        </Suspense>
      </div>
    </BottomSheet>
  );
}
